import React from 'react';

const steps = {
  when: { label: 'When', title: 'An event happens' },
  if: { label: 'If', title: 'These conditions match' },
  then: { label: 'Then', title: 'Cara runs this action' }
} as const;

export const CreationSectionCard = ({
  step,
  aside,
  children
}: React.PropsWithChildren<{
  step: keyof typeof steps;
  aside?: React.ReactNode;
}>) => {
  const id = React.useId();
  return (
    <section
      className="email-creation-card rounded-lg bg-white shadow dark:bg-neutral-800"
      aria-labelledby={id}
      data-step={step}
    >
      <div className="px-4 py-5 sm:px-6">
        <div className="mb-4 flex flex-wrap items-center gap-3">
          <div className="min-w-0 flex-1">
            <p className="m-0 text-sm font-medium text-primary-600 dark:text-primary-400">
              {steps[step].label}
            </p>
            <h3 id={id} className="m-0 text-lg font-medium text-neutral-900 dark:text-white">
              {steps[step].title}
            </h3>
          </div>
          {aside}
        </div>
        {children}
      </div>
    </section>
  );
};
